import { render, staticRenderFns } from "./SpareAdd.vue?vue&type=template&id=74083b19&scoped=true"
import script from "./SpareAdd.vue?vue&type=script&lang=js"
export * from "./SpareAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74083b19",
  null
  
)

export default component.exports